import CloudLoading from '../../components/CloudLoading'
import { copyMarkdown } from '../../utils/commons'
import { showSignOut, useAuthenticatedUser } from '../../providers/UserProvider'
import { useSelectedDateDispatch } from '../../contexts/SelectedDate'
import { useIsMobile } from '../../hooks/useIsMobile'
import { NoteType } from '../../utils/note'
import { NoteTitle } from './NoteTitle'
import { useIsOnline } from '../../providers/NetworkProvider'
import classNames from 'classnames'

type Props = {
  showCalendar: boolean
  toggleCalendar: () => void
  noteType: NoteType
}

export const NoteHeader = ({
  showCalendar,
  toggleCalendar,
  noteType,
}: Props) => {
  const user = useAuthenticatedUser()
  const selectedDateDispatch = useSelectedDateDispatch()
  const isMobile = useIsMobile()
  const isTeamItem =
    noteType === NoteType.TEAM_SPACE_CALENDAR_NOTE ||
    noteType === NoteType.TEAM_SPACE_NOTE
  const isOnline = useIsOnline()

  return (
    <div
      className={classNames(
        'relative flex justify-between pb-1 pl-2.5 pt-0',
        { 'border-b-2 border-dotted border-green-300': isTeamItem },
        { 'opacity-10': !isOnline }
      )}
    >
      <div className='flex w-full items-center'>
        {isMobile && (
          <button
            onClick={toggleCalendar}
            className='absolute left-1.5 bg-transparent text-lg transition md:hidden'
          >
            {showCalendar ? (
              <i className='fa-regular fa-angle-up'></i>
            ) : (
              <i className='fa-solid fa-angle-down'></i>
            )}
          </button>
        )}
        <NoteTitle
          onToday={() => {
            selectedDateDispatch({ type: 'today' })
          }}
        />

        <div className='flex items-center justify-center'></div>
        <div className='flex'>
          <button
            className='mr-2 hidden py-1'
            onClick={(_) => {
              void copyMarkdown()
            }}
          >
            Copy Markdown
          </button>
          <div id='copy-done-check' className='hidden'>
            <i className='fas fa-check'></i>
          </div>
          <button
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Previous day (⌃⌘←)'
            type='button'
            className='hidden flex-none items-center justify-center p-1.5 hover:bg-zinc-100 dark:hover:bg-zinc-700 md:flex'
            onClick={() => {
              selectedDateDispatch({ type: 'shift', direction: -1 })
            }}
          >
            <span className='sr-only'>Previous day</span>
            <i
              className='fa-solid fa-chevron-left h-5 w-5 text-sm'
              aria-hidden='true'
            />
          </button>

          <button
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Next day (⌃⌘→)'
            type='button'
            className='hidden flex-none items-center justify-center p-1.5 hover:bg-zinc-100 dark:hover:bg-zinc-700 md:flex'
            onClick={() => {
              selectedDateDispatch({ type: 'shift', direction: 1 })
            }}
          >
            <span className='sr-only'>Next day</span>
            <i
              className='fa-solid fa-chevron-right h-5 w-5 text-sm'
              aria-hidden='true'
            />
          </button>
        </div>
      </div>

      <div className='hidden pl-5 pr-2 md:flex'>
        <CloudLoading />
        <button
          data-tooltip-id='my-tooltip'
          data-tooltip-content='Logout'
          type='button'
          className='flex flex-none items-center justify-center p-1.5 hover:bg-zinc-100 dark:hover:bg-zinc-700'
          onClick={() => {
            showSignOut(user)
          }}
        >
          <i className='fas fa-user'></i>
        </button>
      </div>
      {!isOnline && <div className='absolute left-0 top-0 h-full w-full' />}
    </div>
  )
}
